const styles = () => ({
  root: {
    '& .MuiInputBase-root': {
      flexDirection: 'row-reverse',
      '& .MuiInputAdornment-positionEnd': {
        marginRight: '8px',
        marginLeft: '0',
      },
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& .MuiSvgIcon-root': {
      color: '#FFC300 !important',
    },
  },
  popoverRoot: {
    '& .MuiPopover-paper': {
      left: '0 !important',
      transformOrigin: 'left top !important',
    },
  },
});

export default styles;
